import { render, staticRenderFns } from "./tags-view.vue?vue&type=template&id=3d5d074a&scoped=true&lang=pug"
import script from "./tags-view.vue?vue&type=script&lang=js"
export * from "./tags-view.vue?vue&type=script&lang=js"
import style0 from "./tags-view.vue?vue&type=style&index=0&id=3d5d074a&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"
import style1 from "./tags-view.vue?vue&type=style&index=1&id=3d5d074a&prod&rel=stylesheet%2Fscss&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5d074a",
  null
  
)

export default component.exports